import { ICheckStockRequest, ICheckStockResponse } from "models/inventory/ICheckStock";
import { erpApi } from "../Api";

const InventoryApi = () => {
    const checkStock = async (request: ICheckStockRequest) => {
        const response = await erpApi.post<ICheckStockResponse>("/api/Inventory/Orders/CheckStock", request);
        return response;
    };

    return { checkStock };
};

export default InventoryApi;
